// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2dDEH","title":"ClientReferral_title__2dGKW","itemText":"ClientReferral_itemText__1mI2U"};